import * as React from 'react';
import SmeConfig from './SmeConfig';

const SmeConfigContext = React.createContext<SmeConfig>({ sections: [] });

export default SmeConfigContext;
